// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__C7MAe","title":"Info_title__2_q9a","links":"Info_links__3B0fD","link":"Info_link__-n4o9","logo":"Info_logo__26Tna"};